import Service from "../Service";

const resource = "monitoringbus/";

export default {
    // Listas y paginación
    list(requestID) {
        return Service.post(resource + "list", "", {
            params: { requestID }
        });
    },
    pagination(dtr, requestID) {
        return Service.post(resource + "pagination", dtr, {
            params: { requestID }
        });
    },
    search(dtr, requestID) {
        return Service.post(resource + "search", dtr, {
            params: { requestID }
        });
    },
    save(dtr, requestID) {
        return Service.post(resource + "save", dtr, {
            params: { requestID }
        });
    },

    // Paraderos
    getBusStops(dtr, requestID) {
        return Service.post(resource + "bus-stops", dtr, {
            params: { requestID }
        });
    },
    createBusStop(dtr, requestID) {
        const payload = {
            BscID: dtr.BscID,
            StpName: dtr.StpName,
            StpLatitude: dtr.StpLatitude,
            StpLongitude: dtr.StpLongitude,
            StpObservation: dtr.StpObservation || '',
            UsrCreateID: dtr.UsrCreateID
        };
        return Service.post(resource + "bus-stops/create", payload, { params: { requestID } });
    },
    updateBusStop(dtr, requestID) {
        const payload = {
            StpID: dtr.StpID,
            BscID: dtr.BscID,
            StpName: dtr.StpName,
            StpLatitude: dtr.StpLatitude,
            StpLongitude: dtr.StpLongitude,
            StpObservation: dtr.StpObservation || '',
            UsrUpdateID: dtr.UsrUpdateID || requestID
        };
        return Service.post(resource + "bus-stops/update", payload, { params: { requestID } });
    },
    deleteBusStop(stpID, requestID, usrUpdateID) {
        return Service.post(resource + "bus-stops/delete", { StpID: stpID, UsrUpdateID: usrUpdateID }, {
            params: { requestID }
        });
    },

    // Rutas 
    getBusRoutesByBus(BscID, requestID) {
        return Service.post(resource + "bus-routes/list", { BscID: BscID }, {
            params: { requestID }
        });
    },
    createBusRoute(data, requestID) {
        return Service.post(resource + "bus-routes/create", {
            BscID: data.BscID,
            RotAlias: data.RotAlias,
            RotStartDate: data.RotStartDate,
            RotEndDate: data.RotEndDate
        }, {
            params: { requestID }
        });
    },
    updateBusRoute(id, data, requestID) {
        return Service.post(resource + "bus-routes/update", {
            RotID: id,
            BscID: data.BscID,
            RotAlias: data.RotAlias,
            RotStartDate: data.RotStartDate,
            RotEndDate: data.RotEndDate
        }, {
            params: { requestID }
        });
    },
    deleteBusRoute(id, requestID) {
        return Service.post(resource + "bus-routes/delete", { RotID: id }, {
            params: { requestID }
        });
    },
    // Crear ruta + paraderos (array stops [{StpID, BrsStopOrder, BrsEstimatedTime}])
    createBusRouteWithStops(data, requestID) {
        return Service.post(resource + "bus-routes/create-with-stops", {
            BscID: data.BscID,
            RotAlias: data.RotAlias,
            RotStartDate: data.RotStartDate,
            RotEndDate: data.RotEndDate,
            Stops: data.Stops || []
        }, { params: { requestID } });
    },
    // Guardar orden masivo (array de {BrsID, BrsStopOrder})
    reorderRouteStops(routeId, items, requestID) {
        // Crear un arreglo compatible con TVP SQL en formato JSON
        const stopsOrderArray = items.map(item => ({
            BrsID: routeId,
            BrsStopOrder: item.BrsStopOrder
        }));

        return Service.post(resource + "bus-routes/stops/reorder", {
            RotID: routeId,
            ReorderData: JSON.stringify(items),
            UsrUpdateID: requestID
        }, { params: { requestID } });
    },
    // Actualizar solo hora estimada
    updateRouteStopTime(routeId, StpID, brsId, time, requestID) {
        return Service.post(resource + "bus-routes/stops/time", {
            RotID: routeId,
            StpID: StpID,
            BrsID: brsId,
            BrsEstimatedTime: time,
            UsrUpdateID: requestID
        }, { params: { requestID } });
    },
    // Upsert masivo de paraderos (para guardar en bloque)
    upsertRouteStops(routeId, stops, requestID) {
        return Service.post(resource + "bus-routes/stops/bulk-upsert", {
            RotID: routeId,
            Stops: stops
        }, { params: { requestID } });
    },

    // Paraderos en ruta (mantener pero asegurando RotID y StpID)
    getRouteStops(routeId, requestID) {
        return Service.post(resource + "bus-routes/stops/list", { RotID: routeId }, {
            params: { requestID }
        });
    },
    addRouteStop(routeId, data, requestID) {
        return Service.post(resource + "bus-routes/stops/create", {
            RotID: routeId,
            StpID: data.StpID,
            BrsStopOrder: data.BrsStopOrder,
            BrsEstimatedTime: data.BrsEstimatedTime
        }, {
            params: { requestID }
        });
    },
    updateRouteStop(routeId, routeStopId, data, requestID) {
        return Service.post(resource + "bus-routes/stops/update", {
            RotID: routeId,
            BrsID: routeStopId,
            StpID: data.StpID,
            BrsStopOrder: data.BrsStopOrder,
            BrsEstimatedTime: data.BrsEstimatedTime,
            UsrCreateID: requestID
        }, {
            params: { requestID }
        });
    },
    deleteRouteStop(routeId, routeStopId, requestID) {
        return Service.post(resource + "bus-routes/stops/delete", { RotID: routeId, BrsID: routeStopId }, {
            params: { requestID }
        });
    },

    // Conductores
    getBusDrivers(BscID, requestID) {
        return Service.post(resource + "bus-driver/list", { BscID: BscID }, {
            params: { requestID }
        });
    },
    saveBusDriver(data, requestID) {
        data.UsrCreateID = requestID;
        return Service.post(resource + "bus-driver/save", data, {
            params: { requestID }
        });
    },
    moveBusDriver(data, requestID) {
        return Service.post(resource + "bus-driver/move", {
            BdrID: data.BdrID,
            TargetBscID: data.TargetBscID,
            UsrUpdateID: requestID
        }, {
            params: { requestID }
        });
    },
    deleteBusDriver(BdrID, requestID) {
        return Service.post(resource + "bus-driver/delete", {
            BdrID: BdrID,
            UsrUpdateID: requestID
        }, {
            params: { requestID }
        });
    }
};